var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-item__wrap"},_vm._l((_vm.items),function(item,ind){return _c('a',{key:ind,staticClass:"medication-aside__item aside-item",attrs:{"href":item.url}},[_c('img',{staticClass:"aside-item__image",attrs:{"src":item.icon}}),_c('div',{staticClass:"aside-item__title",domProps:{"innerHTML":_vm._s(item.title)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }